import * as globalReducers from './globalReducers'
import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'

const rootReducer = combineReducers({
  ...globalReducers,
  form: formReducer
})

export default rootReducer